import { Box, Select, Text } from '@chakra-ui/react'
import { ChangeEvent, memo } from 'react'
import { capitalizeWords, replaceUnderscore } from '../../../utils/functions/formatters'
import InvalidInput from './InvalidInput'

const FormSelect = ({
  label,
  name,
  isInvalid,
  isDisabled,
  invalidText,
  hideLabel,
  placeholderEnabled,
  value,
  w,
  onChange,
  options,
}: {
  label?: string
  name: string
  isInvalid?: boolean
  hideLabel?: boolean
  isDisabled?: boolean
  invalidText?: string
  placeholderEnabled?: boolean
  w?: string | Record<string, string>
  value: string
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
  options: { value: string; label: string }[]
}) => {
  return (
    <Box w={w ?? { base: '100%', md: '50%' }}>
      {!hideLabel && (
        <Text color="neutral.500" fontWeight="600" fontSize="12px" letterSpacing="0.5px" textTransform="uppercase" mb="8px">
          {label ?? capitalizeWords(name)}
        </Text>
      )}
      <Select
        height={{ base: '44px', md: '40px' } as any}
        fontSize={{ base: '16px', md: '14px' } as any}
        borderRadius="7px"
        bg="white"
        borderWidth="0"
        boxShadow="0 1px 3px 0 rgba(0,0,0,0.12), 0 1px 2px -1px rgba(0,0,0,0.08)"
        transition="all 0.15s"
        _hover={{ boxShadow: '0 3px 8px 0 rgba(0,0,0,0.14), 0 1px 3px -1px rgba(0,0,0,0.1)' }}
        _focus={{ boxShadow: '0 0 0 3px rgba(14,4,157,0.12), 0 1px 3px 0 rgba(0,0,0,0.12)', borderColor: 'primary.500' }}
        name={name}
        value={value}
        onChange={onChange}
        isDisabled={isDisabled}
      >
        {placeholderEnabled !== false && <option value="">Select {replaceUnderscore(name)}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <InvalidInput isError={isInvalid || false} label={replaceUnderscore(name)} override={invalidText ?? undefined} />
    </Box>
  )
}

const isEqual = (
  prevProps: { value: string; isInvalid?: boolean; options: { value: string; label: string }[] },
  nextProps: { value: string; isInvalid?: boolean; options: { value: string; label: string }[] }
) => {
  return (
    prevProps.value === nextProps.value &&
    (prevProps.isInvalid || false) === (nextProps.isInvalid || false) &&
    prevProps.options === nextProps.options
  )
}

export default memo(FormSelect, isEqual)
